import React, { useEffect } from "react";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";
import "./EstructuraOrganica.css";

const EstructuraOrganica = () => {
  useEffect(() => {
    document.title = "Estructura Orgánica";
  }, []);

  const publicUrl = process.env.PUBLIC_URL || "";

  return (
    <>
      <Breadcrumbs path={[{ label: "Estructura Orgánica" }]} />
      <TitlePages title="Estructura Orgánica" subTitle="" />

      {/* Imagen original conservada en el proyecto como respaldo (sin mostrarse en pantalla) */}
      <img
        src="https://itetlax.org.mx/assets/img/estOrg/1.webp"
        alt="Respaldo de Estructura Orgánica"
        style={{ display: "none" }}
        aria-hidden="true"
      />

      <section
        className="estorg-section"
        aria-label="Organigrama del Instituto Tlaxcalteca de Elecciones"
      >
        <div className="estorg-diagram-container" role="region" aria-label="Diagrama institucional de estructura orgánica">
          
          {/* Encabezado responsivo: Logotipo en rombo apoyado sobre la primera línea + dos líneas horizontales continuas */}
          <header className="estorg-header">
            <div className="estorg-header-logo-wrap">
              <img
                src={`${publicUrl}/images/estructura/logo-rombo.png`}
                alt="Instituto Tlaxcalteca de Elecciones"
                className="estorg-header-logo"
                loading="eager"
                onError={(e) => {
                  if (!e.currentTarget.dataset.fallback) {
                    e.currentTarget.dataset.fallback = "true";
                    e.currentTarget.src = `${publicUrl}/images/estOrg/logo-rombo.png`;
                  }
                }}
              />
            </div>
            <div className="estorg-header-lines" aria-hidden="true">
              <div className="estorg-header-line" />
              <div className="estorg-header-line" />
            </div>
          </header>

          {/* SVG de conexiones y puntos del organigrama (viewBox 1600 × 1160, activo en desktop/tablet >= 900px) */}
          <svg
            className="estorg-svg"
            viewBox="0 0 1600 1160"
            preserveAspectRatio="xMidYMid meet"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Tronco central vertical en x=799 desde y=425 hasta y=975 */}
            <line
              x1="799"
              y1="425"
              x2="799"
              y2="975"
              stroke="var(--estorg-magenta)"
              strokeWidth="2"
              vectorEffect="non-scaling-stroke"
            />
            {/* Punto magenta en y=500 (tope de Presidencia) */}
            <circle cx="799" cy="500" r="6" fill="var(--estorg-magenta)" />

            {/* Presidencia -> Junta General Ejecutiva: línea punteada horizontal en y=534 de x=930 a x=1082 */}
            <line
              x1="930"
              y1="534"
              x2="1082"
              y2="534"
              stroke="var(--estorg-magenta)"
              strokeWidth="2"
              strokeDasharray="6 4"
              vectorEffect="non-scaling-stroke"
            />
            {/* Punto magenta en x=1075 */}
            <circle cx="1075" cy="534" r="6" fill="var(--estorg-magenta)" />

            {/* Consejo General -> Órgano Interno de Control */}
            <polyline
              points="590,365 378,365 378,579"
              fill="none"
              stroke="var(--estorg-magenta)"
              strokeWidth="2"
              vectorEffect="non-scaling-stroke"
            />
            {/* Punto magenta en x=378, y=571 */}
            <circle cx="378" cy="571" r="6" fill="var(--estorg-magenta)" />

            {/* Secretaría Ejecutiva <-> tronco central en y=692 */}
            <line
              x1="641"
              y1="692"
              x2="799"
              y2="692"
              stroke="var(--estorg-magenta)"
              strokeWidth="2"
              vectorEffect="non-scaling-stroke"
            />
            {/* Punto magenta en x=648, y=692 */}
            <circle cx="648" cy="692" r="6" fill="var(--estorg-magenta)" />

            {/* Secretaría Ejecutiva -> Unidad Técnica de lo Contencioso Electoral */}
            <polyline
              points="377,692 87,692 87,1077 128,1077"
              fill="none"
              stroke="var(--estorg-magenta)"
              strokeWidth="2"
              vectorEffect="non-scaling-stroke"
            />
            {/* Punto gris en x=121, y=1077 */}
            <circle cx="121" cy="1077" r="6" fill="var(--estorg-gray-dot)" />

            {/* Nivel 3 (Direcciones): Bus horizontal en y=765 de x=636 a x=1252 */}
            <line
              x1="636"
              y1="765"
              x2="1252"
              y2="765"
              stroke="var(--estorg-magenta)"
              strokeWidth="2"
              vectorEffect="non-scaling-stroke"
            />
            {/* Bajadas verticales en x=636, x=957, x=1252 hasta y=817 */}
            <line x1="636" y1="765" x2="636" y2="817" stroke="var(--estorg-magenta)" strokeWidth="2" vectorEffect="non-scaling-stroke" />
            <line x1="957" y1="765" x2="957" y2="817" stroke="var(--estorg-magenta)" strokeWidth="2" vectorEffect="non-scaling-stroke" />
            <line x1="1252" y1="765" x2="1252" y2="817" stroke="var(--estorg-magenta)" strokeWidth="2" vectorEffect="non-scaling-stroke" />
            {/* Puntos grises en y=817 */}
            <circle cx="636" cy="817" r="6" fill="var(--estorg-gray-dot)" />
            <circle cx="957" cy="817" r="6" fill="var(--estorg-gray-dot)" />
            <circle cx="1252" cy="817" r="6" fill="var(--estorg-gray-dot)" />

            {/* Nivel 4 (Áreas): Bus horizontal en y=975 de x=524 a x=1346 */}
            <line
              x1="524"
              y1="975"
              x2="1346"
              y2="975"
              stroke="var(--estorg-magenta)"
              strokeWidth="2"
              vectorEffect="non-scaling-stroke"
            />
            {/* Bajadas verticales en x=524, x=799, x=1071, x=1346 hasta y=1030 */}
            <line x1="524" y1="975" x2="524" y2="1030" stroke="var(--estorg-magenta)" strokeWidth="2" vectorEffect="non-scaling-stroke" />
            <line x1="799" y1="975" x2="799" y2="1030" stroke="var(--estorg-magenta)" strokeWidth="2" vectorEffect="non-scaling-stroke" />
            <line x1="1071" y1="975" x2="1071" y2="1030" stroke="var(--estorg-magenta)" strokeWidth="2" vectorEffect="non-scaling-stroke" />
            <line x1="1346" y1="975" x2="1346" y2="1030" stroke="var(--estorg-magenta)" strokeWidth="2" vectorEffect="non-scaling-stroke" />
            {/* Puntos grises en y=1030 */}
            <circle cx="524" cy="1030" r="6" fill="var(--estorg-gray-dot)" />
            <circle cx="799" cy="1030" r="6" fill="var(--estorg-gray-dot)" />
            <circle cx="1071" cy="1030" r="6" fill="var(--estorg-gray-dot)" />
            <circle cx="1346" cy="1030" r="6" fill="var(--estorg-gray-dot)" />
          </svg>

          {/* Lista semántica de elementos del organigrama */}
          <ul className="estorg-list" aria-label="Jerarquía de la Estructura Orgánica">
            {/* 1. Consejo General */}
            <li className="estorg-box estorg-box--cg">
              <span className="estorg-cg-bracket" aria-hidden="true" />
              <span className="estorg-box-dot estorg-box-dot--magenta" aria-hidden="true" />
              <div className="estorg-cg-triangles" aria-hidden="true" />
              <div className="estorg-cg-title">Consejo General</div>
              <div className="estorg-cg-subtitle">
                Consejero Presidente, Consejeras y Consejeros Electorales,<br />
                Secretaria Ejecutiva y Representantes de Partidos Políticos
              </div>
            </li>

            {/* 2. Presidencia */}
            <li className="estorg-box estorg-box--presidencia">
              <span className="estorg-box-dot estorg-box-dot--magenta" aria-hidden="true" />
              <div className="estorg-bold-text">Presidencia</div>
              <div className="estorg-sub-text">del Consejo General</div>
            </li>

            {/* 3. Junta General Ejecutiva */}
            <li className="estorg-box estorg-box--junta">
              <span className="estorg-box-dot estorg-box-dot--magenta" aria-hidden="true" />
              <div className="estorg-bold-text">Junta General Ejecutiva</div>
            </li>

            {/* 4. Órgano Interno de Control */}
            <li className="estorg-box estorg-box--oic">
              <span className="estorg-box-dot estorg-box-dot--magenta" aria-hidden="true" />
              <div className="estorg-bold-text">Órgano Interno de Control</div>
            </li>

            {/* 5. Secretaría Ejecutiva */}
            <li className="estorg-box estorg-box--secretaria">
              <span className="estorg-box-dot estorg-box-dot--magenta" aria-hidden="true" />
              <div className="estorg-bold-text">Secretaría Ejecutiva</div>
            </li>

            {/* 6. Dirección de Organización Electoral */}
            <li className="estorg-box estorg-box--dir estorg-box--dir-org">
              <span className="estorg-box-dot estorg-box-dot--gray" aria-hidden="true" />
              <div className="estorg-text-lower">
                Dirección de Organización Electoral, Capacitación y Educación Cívica
              </div>
            </li>

            {/* 7. Dirección de Prerrogativas */}
            <li className="estorg-box estorg-box--dir estorg-box--dir-prerrogativas">
              <span className="estorg-box-dot estorg-box-dot--gray" aria-hidden="true" />
              <div className="estorg-text-lower">
                Dirección de Prerrogativas, Administración y Fiscalización
              </div>
            </li>

            {/* 8. Dirección de Asuntos Jurídicos */}
            <li className="estorg-box estorg-box--dir estorg-box--dir-juridicos">
              <span className="estorg-box-dot estorg-box-dot--gray" aria-hidden="true" />
              <div className="estorg-text-lower">
                Dirección de Asuntos Jurídicos
              </div>
            </li>

            {/* 9. Unidad Técnica de lo Contencioso Electoral */}
            <li className="estorg-box estorg-box--area estorg-box--utce">
              <span className="estorg-box-dot estorg-box-dot--gray" aria-hidden="true" />
              <div className="estorg-text-lower">
                Unidad Técnica de lo Contencioso Electoral
              </div>
            </li>

            {/* 10. Área Técnica de Informática */}
            <li className="estorg-box estorg-box--area estorg-box--ati">
              <span className="estorg-box-dot estorg-box-dot--gray" aria-hidden="true" />
              <div className="estorg-text-lower">
                Área Técnica de Informática
              </div>
            </li>

            {/* 11. Área Técnica de Comunicación Social y Prensa */}
            <li className="estorg-box estorg-box--area estorg-box--atcsp">
              <span className="estorg-box-dot estorg-box-dot--gray" aria-hidden="true" />
              <div className="estorg-text-lower">
                Área Técnica de Comunicación Social y Prensa
              </div>
            </li>

            {/* 12. Área Técnica de Consulta Ciudadana */}
            <li className="estorg-box estorg-box--area estorg-box--atcc">
              <span className="estorg-box-dot estorg-box-dot--gray" aria-hidden="true" />
              <div className="estorg-text-lower">
                Área Técnica de Consulta Ciudadana
              </div>
            </li>

            {/* 13. Área Técnica de Transparencia y Acceso a la Información */}
            <li className="estorg-box estorg-box--area estorg-box--attai">
              <span className="estorg-box-dot estorg-box-dot--gray" aria-hidden="true" />
              <div className="estorg-text-lower">
                Área Técnica de Transparencia y Acceso a la Información
              </div>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default EstructuraOrganica;
